// extracted by mini-css-extract-plugin
module.exports = {"root":"carousel-slide_root__4oPyQ","item":"carousel-slide_item__3QhY4"};